/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "L23I_XopoA0",
    title: "Silverton Siege",
    imgurl:"https://i.ytimg.com/vi/L23I_XopoA0/maxresdefault.jpg",
    viewCount: "932102",
    publishedAt: "2022-03-24T08:00:00Z",
    channelTitle: "Netflix",
    types:["Action", "Thriller"],
    description:
      "Silverton Siege is an action thriller inspired by true events of 1980 South Africa. A trio of freedom fighters get into a collision course with the state after a failed sabotage mission, which turns into a bank hostage standoff. This film is inspired by the real life incident that sparked the global 'Free Mandela' movement and features Thabo Rametsi, Noxolo Dlamini and Stefan Erasmus, and Arnold Vosloo",
  },
  {
    _id: "Y-ufZuqTd5c",
    title: "The Silence",
    imgurl:"https://nmovies.netlify.app/movies-images/english-movies/the-silence.jpg",
    viewCount: "7588994",
    publishedAt: "2019-03-29T15:00:04Z",
    channelTitle: "Netflix",
    types:["Horror","Sci-Fi"],
    description:
      "When the world is under attack from terrifying creatures who hunt their human prey by sound, 16-year old Ally Andrews (Kiernan Shipka), who lost her hearing at 13, and her family seek refuge in a remote haven. But they discover a sinister cult who are eager to exploit Ally’s heightened senses. Based on the acclaimed novel, THE SILENCE is directed by John R. Leonetti (ANNABELLE) and stars Stanley Tucci, Kiernan Shipka, Miranda Otto, John Corbett, Kate Trotter and Kyle Breitkopf",
  },
  {
    _id: "tFMo3UJ4B4g",
    title: "Arrival (2016)",
    imgurl:"https://nmovies.netlify.app/movies-images/english-movies/arrival.jpg",
    viewCount: "23365125",
    publishedAt: "2016-08-16T14:00:03Z",
    channelTitle: "HBO",
    types:["Aliens","Drama"],
    description:
      "Watch the new official movie trailer for Arrival. Coming to theatres November 11, 2016.\n\nWhen mysterious spacecrafts touch down across the globe, an elite team - lead by expert linguist Louise Banks (Amy Adams) - is brought together to investigate. As mankind teeters on the verge of global war, Banks and the team race against time for answers – and to find them, she will take a chance that could threaten her life, and quite possibly humanity.",
  },
  {
    _id: "FDJDujWJhzw",
    title: "Fantasy Island",
    imgurl:"https://nmovies.netlify.app/movies-images/english-movies/fantasyisland.jpg",
    viewCount: "405359",
    publishedAt: "2020-01-30T12:30:53Z",
    channelTitle: "Netflix",
    types:["Horror","Drama"],
    description:
      "Every fantasy comes at a price. Watch the new trailer for Blumhouse's #FantasyIslandMovie,",
  },

  {
    _id: "INJ2bPFy108",
    title: "Bird Box ",
    imgurl:"https://nmovies.netlify.app/movies-images/english-movies/bird-box.jpg",
    viewCount: "2824581",
    publishedAt: "2018-12-11T20:00:01Z",
    channelTitle: "Netflix",
    types:["Action","Drama","Hindi"],
    description:
      "Never lose sight of survival. \nWatch BirdBox starring Sandra Bullock, exclusive limited theatrical engagements on 12/13 and on Netflix 12/21.",
  },

  {
    _id: "KGC6vl3lzf0",
    title: "Queen",
    imgurl:"https://nmovies.netlify.app/movies-images/hindi-movies/queen.jpg",
    viewCount: "6118596",
    publishedAt: "2013-12-20T19:26:49Z",
    channelTitle: "Prime",
    types:["Action","Drama"],
    description:
      "Aaj rani ki shaadi hai aur woh apne pehle honeymoon ke liye taiyaar hai. Paris aur Amsterdam ke sapne din raat uske mann me chal rahe hain. Aage dekhiye uski shaadi aur honeymoon pe kya kya hota hai.",
  },

  {
    _id: "qN_9DnBh3hM",
    title: "Parmanu",
    imgurl:"https://nmovies.netlify.app/movies-images/hindi-movies/parmanu.jpg",
    viewCount: "3859597",
    publishedAt: "2018-05-11T10:22:59Z",
    channelTitle: "Netflix",
    types:["Documentry","Drama"],
    description:
      "Parmanu The Story Of Pokhran OFFICIAL TRAILER John Abraham, Diana Penty, Boman Irani 2018",
  },

  {
    _id: "M7XM597XO94",
    title: "John Wick: Chapter 3",
    imgurl:"https://i.ytimg.com/vi/M7XM597XO94/maxresdefault.jpg",
    viewCount: "40713077",
    publishedAt: "2019-01-17T17:15:17Z",
    channelTitle: "Netflix",
    types:["Action","Thriller"],
    description:
      "John Wick: Chapter 3 - Parabellum – In theaters May 17, 2019. Starring Keanu Reeves, Halle Berry, Laurence Fishburne, Mark Dacascos, Asia Kate Dillon, Lance Reddick, Saïd Taghmaoui, Jerome Flynn, Jason Mantzoukas, Tobias Segal, Boban Marjanovic, with Anjelica Huston, and Ian McShane.",
  }
];
